import { ListPaginationMeta } from "utils/helpers/pagination";

export interface FloorTypeRow {
  floorTypeId: number;
  floorTypeName: string;
}

export interface FloorTypeForm {
  number: string;
  floorTypeName: string;
}

export type FloorTypeFormFieldKind = "string" | "number";

export const FLOOR_TYPE_FORM_FIELD_KINDS: Record<
  keyof FloorTypeForm,
  FloorTypeFormFieldKind
> = {
  number: "number",
  floorTypeName: "string",
};

export type FloorTypeListMeta = ListPaginationMeta;

export interface FloorTypeListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: FloorTypeRow[];
  meta?: FloorTypeListMeta;
}

export interface FloorTypeUpdatePayload {
  id: number;
  floorTypeName: string;
}

export interface FloorTypeUpdateResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data?: FloorTypeRow;
}

export interface FloorTypeState {
  loading: boolean;
  saving: boolean;
  list: FloorTypeRow[];
  page: number;
  perPage: number;
  meta: FloorTypeListMeta;
  error: string | null;
  isAddModalOpen: boolean;
  form: FloorTypeForm;
}
